import { useState } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import { registerUser } from "../Actions";

export const useSignUpForm = (t) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
        trigger,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: { provider_type_id: "1" } });

  const password = watch("password");

  const onSubmit = async (data, onSuccess,selectCurrency,selectedCountryCode,selectedCity) => {
    setIsSubmitting(true);
    try {
      const payload = {
        name: data.name,
        full_name: data.name,
        provider_type_id: parseInt(data.provider_type_id, 10),
        email: data.email,
        phone: data.phone || "549794341",
        website: data.website || "",
        currency: selectCurrency.value,
        country_id: selectedCountryCode.value,
        city_id: selectedCity.value,
        address: data.address || "",
        postal_code: data.postal_code || "16000",
        password: data.password,
        password_confirmation: data.password_confirmation,
      };

 
      const result = await registerUser(payload);
 
      if (result?.request?.status === true) {
        reset(); 
        message.success(t("registration_successful"));
        onSuccess();
      } else {
 
        message.error(result?.result?.message)
      }
    } catch (error) {
      console.error("Registration error:", error);
      const errors = error.response?.data?.result;
      let errorMessage = t("registration_failed");

      if (errors && typeof errors === "object") {
        const messages = Object.values(errors).flat().filter(Boolean);
        if (messages.length > 0) errorMessage = messages.join(" | ");
      }

      message.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    trigger,
    password,
    setValue,
    clearErrors,
    isSubmitting,
    onSubmit,
  };
};
